import React, { useEffect, useState } from "react";
import { Play, Pause, ChevronRight, ChevronLeft, RotateCcw } from "lucide-react";
import { chartReplay } from "../mock";

const ChartReplay = () => {
  const { bars, entryBar, exitBar, pair, tf, side, pnl } = chartReplay;
  const [idx, setIdx] = useState(entryBar);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    if (!playing) return;
    const id = setInterval(() => {
      setIdx((i) => {
        if (i >= bars.length - 1) { setPlaying(false); return i; }
        return i + 1;
      });
    }, 350);
    return () => clearInterval(id);
  }, [playing, bars.length]);

  const W = 520, H = 220, pad = 10;
  const min = Math.min(...bars), max = Math.max(...bars);
  const bw = (W - pad * 2) / bars.length;
  const y = (v) => pad + (1 - (v - min) / (max - min)) * (H - pad * 2);

  return (
    <div className="ws-panel p-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="ws-heading text-[17px] font-semibold">Chart Replay</h3>
          <p className="text-[12px] text-[color:var(--ws-muted)]">Step back into the trade, bar by bar.</p>
        </div>
        <div className="text-right">
          <div className="ws-heading font-semibold text-white text-[14px]">
            {pair} <span className="text-[color:var(--ws-muted)]">{tf}</span>
            <span className="ws-up ml-2">{side}</span>
          </div>
          <div className="text-[12px] ws-up font-semibold">{pnl}</div>
        </div>
      </div>

      <div className="ws-price-cell p-3 mb-4 overflow-x-auto">
        <svg width={W} height={H} className="mx-auto block" style={{ maxWidth: "100%" }}>
          {bars.map((v, i) => {
            const prev = i === 0 ? v : bars[i - 1];
            const up = v >= prev;
            const shown = i <= idx;
            const cx = pad + i * bw + bw / 2;
            const top = y(Math.max(v, prev));
            const bot = y(Math.min(v, prev));
            const isEntry = i === entryBar, isExit = i === exitBar;
            return (
              <g key={i} className={`${up ? "ws-candle-up" : "ws-candle-down"} ${shown ? "" : "ws-candle-dim"}`}>
                <line x1={cx} y1={top - 6} x2={cx} y2={bot + 6} strokeWidth="1" />
                <rect x={cx - bw * 0.28} y={top} width={bw * 0.56} height={Math.max(bot - top, 2)} rx="1" />
                {isEntry && shown && <circle cx={cx} cy={y(v)} r="4" fill="#38bdf8" />}
                {isExit && shown && <circle cx={cx} cy={y(v)} r="4" fill="#a78bfa" />}
              </g>
            );
          })}
        </svg>
      </div>

      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <button onClick={() => setIdx((i) => Math.max(0, i - 1))} className="ws-btn-ghost w-9 h-9 rounded-lg flex items-center justify-center"><ChevronLeft className="w-4 h-4" /></button>
          <button onClick={() => setPlaying((p) => !p)} className="ws-btn-primary w-10 h-10 rounded-lg flex items-center justify-center">
            {playing ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
          </button>
          <button onClick={() => setIdx((i) => Math.min(bars.length - 1, i + 1))} className="ws-btn-ghost w-9 h-9 rounded-lg flex items-center justify-center"><ChevronRight className="w-4 h-4" /></button>
          <button onClick={() => { setIdx(entryBar); setPlaying(false); }} className="ws-btn-ghost w-9 h-9 rounded-lg flex items-center justify-center"><RotateCcw className="w-4 h-4" /></button>
        </div>
        <div className="text-[12px] text-[color:var(--ws-muted)]">
          bar <span className="text-white font-semibold">{idx + 1}</span> / {bars.length}
          <span className="mx-2 text-[color:var(--ws-cyan)]">● entry</span>
          <span className="text-[#a78bfa]">● exit</span>
        </div>
      </div>
    </div>
  );
};

export default ChartReplay;
